import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ExpressStoreRegistrationService} from '../../networking/services/express-store-registration/express-store-registration.service';
import {GetCustomerExpressResponse, iUpdateUserExpress} from '../../networking/models/express-store-registration/express-store-registration';
import { SessionStorageManager } from '../session-storage/session-storage.manager';
import { IpService } from '../../networking/services/customer/ip.service';
import { IpRes } from '../../networking/models/customer/responses/ip-res';

@Injectable({
  providedIn: 'root',
})
export class ExpressStoreRegistrationManager {
  constructor(
    private service: ExpressStoreRegistrationService,
    private sessionStorageMg: SessionStorageManager,
    private ipService: IpService,
  ) {}

  getCustomerExpress(): Observable<GetCustomerExpressResponse> {
    const tokenUser = this.sessionStorageMg.get('dataTemporal');

    const dataGetCustomer = {
      token: tokenUser.token || tokenUser.tokensDatastore?.token,
      tokenIdWebSafe: tokenUser.tokenIdWebSafe || tokenUser.tokensDatastore?.tokenIdWebSafe,
      idCustomerWebSafe: tokenUser.idCustomerWebSafe || tokenUser.tokensDatastore?.idCustomerWebSafe,
    }

    return this.service.getCustomerExpress(dataGetCustomer);
  }

  updateCustomerExpress(data, selfCheckout): Observable<iUpdateUserExpress> {

    const tokenUser = this.sessionStorageMg.get('dataTemporal');

    const dataComplete = {
      ...data,
      analyticsUUID: tokenUser.analyticsUUID,
      idCustomerWebSafe: tokenUser.idCustomerWebSafe,
      token: {
          token: tokenUser.token,
          tokenIdWebSafe: tokenUser.tokenIdWebSafe,
      },
    }

    return this.service.updateCustomerExpress(dataComplete, tokenUser.customerRef, selfCheckout);
  }

  getIpAddress(): Observable<IpRes> {
    return this.ipService.getIpAddress();
  }
}
